export enum FeatureLimitsTypes {
  Boolean = 'boolean',
  String = 'string',
  Array = 'array',
  Integer = 'integer',
  Float = 'float',
}

export enum FeatureLimitsKeys {
  'approval' = 'approval_app',
  'cloudinary' = 'has_cloudinary_app',
  'export' = 'has_lang_export_app',
  'import' = 'has_lang_import_app',
  'optimizely' = 'has_optimizely_app',
  'seo' = 'has_seo_meta_tags_app',
  'shared_components' = 'has_shared_components_app',
  'storyblok-gmbh@ai-seo' = 'has_ai_seo_app',
  'storyblok-gmbh@vwo' = 'has_vwo_app',
  'storyblok-gmbh@bigcommerce-fieldtypes' = 'has_bigcommerce_app',
  'storyblok-gmbh@broken-links-checker' = 'has_broken_links_checker_app',
  'storyblok-gmbh@bynder' = 'has_bynder_app',
  'storyblok-gmbh@centra' = 'has_centra_app',
  'storyblok-gmbh@code-block' = 'has_codeblock_app',
  'storyblok-gmbh@commerce-layer' = 'has_commercelayer_app',
  'storyblok-gmbh@commercetools-fieldtypes' = 'has_commercetools_app',
  'storyblok-gmbh@netlify' = 'has_netlify_app',
  'storyblok-gmbh@palette' = 'has_palette_app',
  'storyblok-gmbh@saleor-fieldtypes' = 'has_saleor_app',
  'storyblok-gmbh@salesforce' = 'has_salesforce_app',
  'storyblok-gmbh@sap' = 'has_sap_app',
  'storyblok-gmbh@semrush-keywords-app-extension' = 'has_semrush_app',
  'storyblok-gmbh@shopify' = 'has_shopify_app',
  'storyblok-gmbh@shopify-v2' = 'has_shopify_v2_app',
  'storyblok-gmbh@akeneo' = 'has_akeneo_app',
  'storyblok-gmbh@inriver' = 'has_inriver_app',
  'storyblok-gmbh@shopware-fieldstypes' = 'has_shopware_app',
  'storyblok-gmbh@slack' = 'has_slack_app',
  'storyblok-gmbh@slider' = 'has_slider_app',
  'storyblok-gmbh@smartling' = 'has_smartling_app',
  'storyblok-gmbh@algolia' = 'has_algolia_app',
  'storyblok-gmbh@spryker-fieldtypes' = 'has_spryker_app',
  'storyblok-gmbh@swell-fields' = 'has_swell_app',
  'storyblok-gmbh@sylius-fieldtypes' = 'has_sylius_app',
  'storyblok-gmbh@vendure-fieldtypes' = 'has_vendure_app',
  'storyblok-gmbh@vercel' = 'has_vercel_app',
  ActivityLog = 'has_activity_log_app',
  ActivityLogFilterByType = 'has_activity_log_filter_by_type',
  ActivityLogFilterByUser = 'has_activity_log_filter_by_user',
  ActivityLogFilterPeriod = 'activity_log_period_in_days',
  ActivityUserMonthlyFee = 'additional_user_monthly_fee',
  AiTokensMonthlyLimit = 'ai_tokens_monthly_limit',
  AiCreditsMonthlyLimit = 'ai_credits_monthly',
  ApiRequestMonthlyLimit = 'api_requests_monthly_limit',
  ApiWhitelabeling = 'has_api_whitelabeling',
  ApiWhitelabelingCName = 'has_api_whitelabeling_cname',
  AppAccessTokenScope = 'has_access_token_scopes_app',
  AppAdvancedPaths = 'has_advanced_paths_app',
  AppAutoSave = 'has_autosave_app',
  AppClipboardHistory = 'has_clipboard_history_app',
  AppColorPicker = 'has_colorpicker_app',
  AppContentLocking = 'has_content_locking_app',
  AppCustom = 'has_custom_apps',
  AppLokalise = 'has_lokalise_app',
  AppTaskManager = 'has_task_manager',
  AppTrash = 'has_trash_app',
  AssetWhiteLabeling = 'has_asset_whitelabeling',
  Assets = 'assets',
  Blocks = 'components',
  CanAddExtraUsers = 'can_add_extra_users',
  CanForce2FA = 'can_force_two_factor_authentication',
  CanHaveFavoriteStories = 'can_have_favourite_stories',
  CanSelectServerRegion = 'can_select_server_region',
  Collaboration = 'has_collaboration',
  ConditionalFields = 'has_field_conditional_settings',
  ContentFolders = 'content_folders',
  CustomMaxAssetSize = 'has_custom_max_upload_size',
  CustomMetadata = 'asset_custom_metadata',
  CustomRoles = 'custom_roles',
  CustomRolesGrainedControl = 'fine_grained_access_control',
  CustomStages = 'custom_stages',
  CustomWorkflows = 'custom_workflows',
  Datasources = 'datasources',
  DefaultStages = 'default_stages',
  Discussion = 'has_discussion',
  FreeSeatsIncluded = 'free_seats_included',
  HasAdditionalUsageApiRequests = 'has_additional_usage_api_requests',
  HasAdditionalUsageAssets = 'has_additional_usage_assets',
  HasAdditionalUsageLocales = 'has_additional_usage_locales',
  HasAdditionalUsageStories = 'has_additional_usage_stories',
  HasAdditionalUsageTrafficVolume = 'has_additional_usage_traffic_volume',
  HasAdditionalUsageAiCredits = 'has_additional_usage_ai_credits',
  HasDimensionsApp = 'has_dimensions_app',
  HasGraphql = 'has_graphql',
  HasHistoryCompare = 'has_history_compare',
  HasHistoryVisual = 'has_history_visual',
  ImageService = 'has_image_service',
  Locales = 'locales',
  MaxAdditionalUsageApiRequests = 'max_additional_usage_api_requests_monthly_limit',
  MaxAdditionalUsageAssets = 'max_additional_usage_assets',
  MaxAdditionalUsageLocales = 'max_additional_usage_locales',
  MaxAdditionalUsageStories = 'max_additional_usage_stories',
  MaxAdditionalUsageTrafficVolume = 'max_additional_usage_traffic_monthly_in_gb',
  MaxAdditionalUsageAiCredits = 'max_additional_usage_ai_credits',
  MaxAssetSize = 'max_asset_size_in_mb',
  MaxCollaborators = 'max_collaborators',
  MonthlyTraffic = 'traffic_monthly_in_gb',
  NacelleApp = 'has_nacelle_app',
  Pipelines = 'pipelines',
  PreviewUrls = 'preview_urls',
  Releases = 'releases',
  HasReleasePermission = 'has_release_permission',
  ReplaceAsset = 'has_replace_assets_app',
  RestrictedIpAddressRange = 'has_restricted_ip_address_range',
  S3BackupFrequency = 'has_backup_app',
  SingleSchedule = 'schedule_single_story',
  Spaces = 'spaces_included',
  SpacesPro = 'spaces_pro_included',
  SpacesStandard = 'spaces_standard_included',
  SSO = 'sso',
  StackedStories = 'stacked_view',
  Stories = 'stories',
  StoryHistoryRetention = 'story_history_retention_in_days',
  TranslatableAssetMetadata = 'has_translatable_asset_metadata',
  TranslatableSlugs = 'has_translatable_slugs_app',
  UnpublishedDependencies = 'has_unpublished_dependencies_alert',
  WebHookSecrets = 'has_webhook_secret',
  WebHooks = 'webhooks',
  WebhookLogRetention = 'webhook_log_retention_in_days',
  WireTransferPayment = 'has_wire_transfer_payment',
  WorkflowDeadlineNotification = 'has_workflow_deadline_notification',
  CustomAiSetupOrgLevel = 'custom_ai_setup_org_level',
  CustomAiSetupSpaceLevel = 'custom_ai_setup_space_level',
  CanSetupAiOnFeatureLevel = 'can_setup_ai_on_feature_level',
  AiStyleOrgGroups = 'ai_style_org_groups',
  AiStyleOrgRules = 'ai_style_org_rules',
  AiStyleSpaceGroups = 'ai_style_space_groups',
  AiStyleSpaceRules = 'ai_style_space_rules',
  AiStyleFeatureLevelConfig = 'ai_style_feature_level_config',
  AiStyleSelectableOptions = 'ai_style_selectable_options',
  AiBranding = 'ai_branding',
}
